import React, { useState } from 'react'
import useHideTopMessageBox from '../hooks/useHideTopMessageBox'
import styles from '../style'
import propTypes from '../prop'
import { withStyles, Tooltip, Typography } from '@material-ui/core'
import withMediaLayout from '../layout-hoc'
import URL from '../../../../api/url'
import ConverterDateToShortFormat from '../../../../utils/converter/date-to-short-format'
import Zoom from '@material-ui/core/Zoom'
import debounce from 'lodash.debounce'

import {
  ButtonType,
  ButtonData,
  ButtonActionType,
} from '../../../../model/button'
import MessageBoxContent, {
  MessageBoxType,
  MessageBoxVariant,
} from '../../../../model/message-box'

import { messageBoxShowAction } from '../../../../reducers/message-box/action'

import { mediaImageDeleteAction } from '../../../../reducers/media-image/action'
import { CoreIconButton } from 'src/components/core'
import { Icon } from '@iconify/react'
/**
 *
 * @param {*} props
 */
const MediaItemImage = props => {
  const { classes, url, name, createDate, onSelect, dispatch, id, refreshList } =
    props
  const [hideItem, setHideItem] = useState(true)
  const [displayItem, setDisplayItem] = useState('flex')
  const hideTopMessageBox = useHideTopMessageBox(dispatch)

  const handleSelect = debounce(() => {
    onSelect(props)
  }, 500)

  const onDelete = () => {
    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.ERROR,
          buttons: [
            new ButtonData(
              ButtonType.NORMAL,
              'Cancel',
              ButtonActionType.NO,
              () => {
                hideTopMessageBox()
              },
            ),
            new ButtonData(
              ButtonType.ACTION,
              'Delete',
              ButtonActionType.DELETE,
              () => {
                dispatch(
                  mediaImageDeleteAction({ id }, () => {
                    if (typeof refreshList === 'function') {
                      refreshList()
                    } else {
                      setHideItem(false)
                    }
                    hideTopMessageBox()
                  }),
                )
              },
            ),
          ],
          title: 'Delete media',
          note: '',
          description:
            'This action cannot be undone. Are you sure you want to delete this media permanently?',
          variant: MessageBoxVariant.NOTICE,
        }),
      ),
    )
  }
  return (
    <Zoom in={hideItem} onExited={() => setDisplayItem('none')} appear={false}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div
          className={classes.bordersHolder}
          style={{
            display: displayItem,
          }}
        >
          <div className={classes.imageViewContainer}>
            <img
              src={URL.STORAGE + url}
              className={classes.imageContent}
              alt=""
              onClick={handleSelect}
              draggable={false}
            />
          </div>
          <CoreIconButton
            className={classes.deleteButton}
            color="white"
            variant="contained"
            size="small"
            onClick={onDelete}
          >
            <Icon icon="bx:trash-alt" />
          </CoreIconButton>
          <CoreIconButton
            size="small"
            variant="contained"
            color="primary"
            onClick={handleSelect}
            className={classes.titleWrapActionPosRight}
          >
            <Icon icon="ic:round-plus" />
          </CoreIconButton>
        </div>
        <Tooltip title={<Typography>{name || '-'}</Typography>}>
          <div
            className={classes.titleBar}
            style={{
              padding: '4px',
              cursor: 'pointer',
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <div
              style={{
                width: '100%',
              }}
            >
              <Typography
                className={classes.title}
                style={{
                  display: '-webkit-box',
                  WebkitLineClamp: 1,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  width: '100%', // Accounting for padding and action button width
                  wordBreak: 'break-word',
                  lineHeight: '1.4em',
                  maxHeight: '2.4em', // 2 lines * 1.2em line-height
                  textAlign: 'center',
                }}
              >
                {name || '-'}
              </Typography>
              <Typography className={classes.subtitleAdditional}>
                {ConverterDateToShortFormat(createDate)}
              </Typography>
            </div>
          </div>
        </Tooltip>
      </div>
    </Zoom>
  )
}

MediaItemImage.propTypes = propTypes

export default withMediaLayout(withStyles(styles)(MediaItemImage))
